import { useAdminAuth } from '../AuthContext';
import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAdminAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: '#F5F8FA' }}>
        <div className="w-8 h-8 border-2 rounded-full animate-spin" style={{ borderColor: '#CBD6E2', borderTopColor: '#FF7A59' }} />
      </div>
    );
  }

  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
